import { Button, makeStyles, createStyles } from "@material-ui/core";
import React, { useEffect, useMemo } from "react";
import AddIcon from "@material-ui/icons/Add";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import CreateDeploymentDialog from "../../components/CreateDeploymentDialog";
import { regionItemsToRegionGroups } from "../../config/deploymentRegions";
import { ApiRegionsService } from "../../services/ApiService";
import type { DeploymentCreatorProps } from "./deploymentCreatorTypes";

const DEPLOYMENT_HEADER_CONTROL_HEIGHT = 40;

const useStyles = makeStyles((theme) =>
  createStyles({
    addButton: {
      height: DEPLOYMENT_HEADER_CONTROL_HEIGHT,
      minHeight: DEPLOYMENT_HEADER_CONTROL_HEIGHT,
      padding: theme.spacing(0, 2),
    },
  })
);

export const DeploymentCreatorRegional: React.FC<DeploymentCreatorProps> = ({
  resourceAppId,
  version,
  refreshDeploymentList,
  deployedRegions,
  basePath,
  onDeploymentAdded,
}) => {
  const { open, toggle } = useDialogProps();
  const { state: regionsState, subscribe: fetchRegions } = useAsyncAction(() =>
    ApiRegionsService.getRegions()
  );

  useEffect(() => {
    if (open) fetchRegions();
  }, [open, fetchRegions]);

  const regionGroups = useMemo(() => {
    if (!regionsState?.loaded || !regionsState?.value) return [];
    return regionItemsToRegionGroups(regionsState.value);
  }, [regionsState?.loaded, regionsState?.value]);

  const onSuccess = () => {
    refreshDeploymentList();
    toggle();
    onDeploymentAdded?.();
  };

  const isFedRamp = process.env.REACT_APP_IS_FEDRAMP === "true";
  const canAddDeployment = isFedRamp
    ? !deployedRegions || deployedRegions.length === 0
    : true;

  const classes = useStyles();

  return (
    <>
      <Button
        disabled={!canAddDeployment}
        size="medium"
        variant="contained"
        color="primary"
        className={classes.addButton}
        startIcon={<AddIcon />}
        onClick={() => toggle()}
      >
        Add New Deployment
      </Button>
      <CreateDeploymentDialog
        open={open}
        onClose={toggle}
        onSuccess={onSuccess}
        basePath={basePath}
        resourceAppId={resourceAppId}
        version={version}
        regionGroups={regionGroups}
        deployedRegions={deployedRegions}
      />
    </>
  );
};
